import { useIntl } from "react-intl";

type TData = {
    data: {
        isValid: boolean;
        price: number;
        domain: string;
        ip: any;
        registrarAccount: {
            email: string;
            name: string;
            registrar: string;
        };
    };
};
const SiteConfirmationBody: React.FC<TData> = ({ data }) => {
    const { formatMessage } = useIntl();

    return (
        <div className="text-center">
            <h1 className="text-primary">{data?.domain}</h1>
            <p className="form-label">{formatMessage({ id: "sites.confirmation.boughtOn" })}</p>
            <p className="form-label">
                <span className="text-primary">{data?.registrarAccount?.registrar} </span>(
                {data?.registrarAccount?.email})
            </p>
            <p className="form-label">{formatMessage({ id: "sites.confirmation.priceOf" })} :</p>
            <p className="form-label text-primary">
                {data?.price == 0 || data?.price == 999
                    ? data?.price == 0
                        ? formatMessage({ id: "sites.confirmation.standardPrice" })
                        : formatMessage({ id: "sites.confirmation.premiumPrice" })
                    : `${data?.price} €`}{" "}
            </p>
        </div>
    );
};
export default SiteConfirmationBody;
